<button
  type="button"
  class="filter-select"
  [class.filter-select--active]="!!value"
  [matMenuTriggerFor]="menu"
  [disabled]="disabled"
>
  <span>{{ selectedLabel }}</span>
  <span class="material-icons filter-select__chevron">expand_more</span>
</button>

<mat-menu #menu="matMenu" class="filter-select-panel">
  <button mat-menu-item [class.active]="!value" (click)="select('')">{{ allLabel }}</button>
  @for (opt of options; track opt.value) {
    <button mat-menu-item [class.active]="value === opt.value" (click)="select(opt.value)">{{ opt.label }}</button>
  }
</mat-menu>
